export enum FilasExcel {
    PREGUNTA_ID, TIPO_PREGUNTA, TEXTO_PREGUNTA, ALEATORIO, REFERENCIA, ITEMS, PREGUNTA_SIGUIENTE,
    KILLER, VISIBLE_SI, MIN_MAX, CUSTOMER_ID, BLOQUE_ID, TIPO_OPCIONES
}

const columnaMap = new Map<FilasExcel, string>();
columnaMap.set(FilasExcel.PREGUNTA_ID, "##Pregunta #");
columnaMap.set(FilasExcel.TIPO_PREGUNTA, "##Tipo de pregunta");
columnaMap.set(FilasExcel.TEXTO_PREGUNTA, "##Pregunta");
columnaMap.set(FilasExcel.ALEATORIO, "##Random");
columnaMap.set(FilasExcel.REFERENCIA, "##Referencia");
columnaMap.set(FilasExcel.ITEMS, "##Items");
columnaMap.set(FilasExcel.PREGUNTA_SIGUIENTE, "##Pregunta Siguiente");
columnaMap.set(FilasExcel.KILLER, "##Killer");
columnaMap.set(FilasExcel.VISIBLE_SI, "##Visible Si");
columnaMap.set(FilasExcel.MIN_MAX, "##Min/Max");
columnaMap.set(FilasExcel.CUSTOMER_ID, "##Customer ID");
columnaMap.set(FilasExcel.BLOQUE_ID, "##Bloque ID");
columnaMap.set(FilasExcel.TIPO_OPCIONES, "##Tipos de opciones");

const columnaArray = new Map<FilasExcel, string>();
columnaArray.set(FilasExcel.PREGUNTA_ID, "0");
columnaArray.set(FilasExcel.TIPO_PREGUNTA, "1");
columnaArray.set(FilasExcel.TEXTO_PREGUNTA, "2");
columnaArray.set(FilasExcel.ALEATORIO, "3");
columnaArray.set(FilasExcel.REFERENCIA, "4");
columnaArray.set(FilasExcel.ITEMS, "5");
columnaArray.set(FilasExcel.PREGUNTA_SIGUIENTE, "6");
columnaArray.set(FilasExcel.KILLER, "7");
columnaArray.set(FilasExcel.VISIBLE_SI, "8");
columnaArray.set(FilasExcel.MIN_MAX, "9");
columnaArray.set(FilasExcel.CUSTOMER_ID, "10");
columnaArray.set(FilasExcel.BLOQUE_ID, "11");
columnaArray.set(FilasExcel.TIPO_OPCIONES, "7");

const columnaNuevoArray = new Map<FilasExcel, string>();
columnaNuevoArray.set(FilasExcel.PREGUNTA_ID, "0");
columnaNuevoArray.set(FilasExcel.TIPO_PREGUNTA, "1");
columnaNuevoArray.set(FilasExcel.TEXTO_PREGUNTA, "2");
columnaNuevoArray.set(FilasExcel.REFERENCIA, "3");
columnaNuevoArray.set(FilasExcel.ITEMS, "4");
columnaNuevoArray.set(FilasExcel.PREGUNTA_SIGUIENTE, "5");
columnaNuevoArray.set(FilasExcel.TIPO_OPCIONES, "6");
columnaNuevoArray.set(FilasExcel.VISIBLE_SI, "7");
columnaNuevoArray.set(FilasExcel.MIN_MAX, "8");
columnaNuevoArray.set(FilasExcel.CUSTOMER_ID, "9");
columnaNuevoArray.set(FilasExcel.BLOQUE_ID, "10");

export const obtenerColumnaMap: (fila: FilasExcel) => string = fila => columnaMap.get(fila) ?? "";
export const obtenerColumnaArray: (fila: FilasExcel) => string = fila => columnaArray.get(fila) ?? "";
export const obtenerColumnaNuevoArray: (fila: FilasExcel) => string = fila => columnaNuevoArray.get(fila) ?? "";

export const obtenerColumnas: () => FilasExcel[] = () => Array.from(columnaMap.keys());
